import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    notSetTitle: {
        id: "experienceEditor.notEnabled.title",
    },
    notSetButton: {
        id: "experienceEditor.notEnabled.button",
    },
    order: {
        id: "experienceEditor.order.label"
    },
    fix: {
        id: "experienceEditor.order.fix",
    },
    free: {
        id: "experienceEditor.order.free"
    },
    info: {
        id: "experienceEditor.info",
    },
    scoreOptionScore: {
        id: "experienceEditor.score.options.score",
    },
    scoreOptionTaskScore: {
        id: "experienceEditor.score.options.taskScore",
    },
    scoreLabel: {
        id: "experienceEditor.score.label",
    },
    coverImage: {
        id: "testModeration.categories.cover",
    },
    easter: {
        id: "easter.eggPainting",
    },
    christmas: {
        id: "christmas.title"
    },
    theme: {
        id: "experienceEditor.theme",
    },
    basic: {
        id: "experienceEditor.theme.basic",
    },
});

export default messages;